import { modalValidacaoPlanilhaRegularizacaoStyles } from './ModalValidacaoPlanilhaRegularizacao.styles'

export function modalValidacaoPlanilhaRegularizacaoIO() {
  return {
    styles: modalValidacaoPlanilhaRegularizacaoStyles
  }
}

export type ModalValidacaoPlanilhaRegularizacaoIO = ReturnType<typeof modalValidacaoPlanilhaRegularizacaoIO>
